import Sidebar from "../../components/Sidebar";
import React, { useState, useEffect } from "react";
import { useUser } from "../../context/userContext";
import axios from "axios";
import ProductTable from "../../components/product_superAdmin/ProductsTable";
import AddProductModal from "../../components/product/AddProductModal";
import EditProductModal from "../../components/product/EditProductModal";
import PreviewProductModal from "../../components/product/PreviewModal";
import DeleteModal from "../../components/product/DeleteModal";

const ProductAdmin = () => {
  const [categoryAttributes, setCategoryAttributes] = useState([]);
  const [categoryAttributeValues, setCategoryAttributeValues] = useState({});
  const [subcategoryAttributes, setSubcategoryAttributes] = useState([]);
  const [subcategoryAttributeValues, setSubcategoryAttributeValues] = useState(
    {}
  );
  const [products, setProducts] = useState([]);
  const { user } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isPreviewModalOpen, setPreviewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  console.log(user);
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 5;
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );
  const totalPages = Math.ceil(products.length / productsPerPage);
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
  const handleDelete = async () => {
    if (selectedProduct) {
      console.log("Selected product:", selectedProduct);
      try {
        const response = await axios.delete(
          `https://api.theonlysale.com/api/product/delete/${selectedProduct.id}`
        );

        if (response.status >= 200 && response.status < 300) {
          console.log("Product deleted successfully");
          setIsDeleteModalOpen(false);
          fetchProducts();
        } else {
          console.error("Failed to delete product");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  console.log("Products in ProductAdmin:", products);

  useEffect(() => {
    if (user?.id) {
      fetchProducts();
    }
  }, [user]);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  useEffect(() => {
    const fetchAllCategories = async () => {
      try {
        const response = await axios.get(
          "https://api.theonlysale.com/api/categories/get"
        );
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchAllCategories();
  }, []);
  useEffect(() => {
    const fetchSubcategories = async (categories) => {
      console.log("categories", categories.category_id);
      try {
        const response = await axios.get(
          `https://api.theonlysale.com/api/subcategory/getByCategory/${categories}`
        );
        setSubcategories(response.data);
        setSelectedSubcategory("");
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    };

    if (selectedCategory) {
      fetchSubcategories(selectedCategory);
    } else {
      setSubcategories([]);
    }
  }, [selectedCategory]);
  const toggleDropdown = (productId) => {
    setOpenDropdownId((prevId) => (prevId === productId ? null : productId));
  };
  const handleEditModalOpen = (product) => {
    setSelectedProduct(product);
    setEditModalOpen(true);
  };
  const handlePreviewModalOpen = (product) => {
    setSelectedProduct(product);
    setPreviewModalOpen(true);
  };
  const toggleEditModal = () => {
    setEditModalOpen(!isEditModalOpen);
  };
  const togglePreviewModal = () => {
    setPreviewModalOpen(!isPreviewModalOpen);
  };
  const handleDeleteModalOpen = (product) => {
    console.log("Delete modal opened:", product);
    setSelectedProduct(product);
    setIsDeleteModalOpen(true);
  };
  const toggleDeleteModal = () => {
    console.log("Toggling delete modal:", !isDeleteModalOpen);
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSelectedProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };
  const handleEditProduct = (event) => {
    event.preventDefault();
    toggleEditModal();
  };
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `https://api.theonlysale.com/api/product/get`
      );

      console.log("responsi", response.data);
      let updatedProducts = response.data.map((product) => {
        let imagesArray = [];
        try {
          imagesArray = JSON.parse(product.images);
        } catch (e) {
          console.error("Error parsing images array:", e);
        }

        const firstImage = imagesArray.length > 0 ? imagesArray[0] : null;
        const imageURIs = imagesArray.map(
          (image) =>
            `https://api.theonlysale.com/uploads/images/${image.split(/[\\/]/).pop()}`
        );

        return {
          ...product,
          imageURI: firstImage
            ? `https://api.theonlysale.com/uploads/images/${firstImage
                .split(/[\\/]/)
                .pop()}`
            : null,
          imageURIs,
        };
      });
      setProducts(updatedProducts);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const handleRemoveImage = (index) => {
    const updatedImageURIs = [...selectedProduct.imageURIs];
    updatedImageURIs.splice(index, 1);
    setSelectedProduct({
      ...selectedProduct,
      imageURIs: updatedImageURIs,
    });
  };
  useEffect(() => {
    if (isEditModalOpen || isModalOpen || isPreviewModalOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isEditModalOpen, isModalOpen, isPreviewModalOpen]);

  return (
    <>
      <div className="flex min-h-screen">
        <div className="w-64">
          <Sidebar />
        </div>
        <div className="flex-grow dark:bg-gray-900">
          <ProductTable
            currentProducts={currentProducts}
            indexOfFirstProduct={indexOfFirstProduct}
            indexOfLastProduct={indexOfLastProduct}
            productsLength={products.length}
            toggleModal={toggleModal}
            totalPages={totalPages}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            toggleDropdown={toggleDropdown}
            openDropdownId={openDropdownId}
            handleEditModalOpen={handleEditModalOpen}
            handlePreviewModalOpen={handlePreviewModalOpen}
            handleDeleteModalOpen={handleDeleteModalOpen}
          />
        </div>
        <EditProductModal
          isEditModalOpen={isEditModalOpen}
          toggleEditModal={toggleEditModal}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          categories={categories}
          subcategories={subcategories}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          setSelectedSubcategory={setSelectedSubcategory}
          handleInputChange={handleInputChange}
          selectedSubcategory={selectedSubcategory}
          fetchProducts={fetchProducts}
          handleEditProduct={handleEditProduct}
        />
        <PreviewProductModal
          isPreviewModalOpen={isPreviewModalOpen}
          togglePreviewModal={togglePreviewModal}
          selectedProduct={selectedProduct}
        />
        <DeleteModal
          isDeleteModalOpen={isDeleteModalOpen}
          toggleDeleteModal={toggleDeleteModal}
          handleDelete={handleDelete}
        />
      </div>
    </>
  );
};
export default ProductAdmin;
